import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  basicInfo: {
    id: 'Label.BasicInfo',
    defaultMessage: 'Basic Information'
  },
  topicsAndStandards: {
    id: 'Label.TopicsAndStandards',
    defaultMessage: 'Topics & Standards'
  },
  images: {
    id: 'Label.Images',
    defaultMessage: 'Images'
  },
  otherInfo: {
    id: 'Label.OtherInfo',
    defaultMessage: 'Other Information'
  },
  questReview: {
    id: 'Label.QuestReview',
    defaultMessage: 'Quest Review'
  },
  standards: {
    id: 'Label.Standards',
    defaultMessage: 'Standards'
  },
  final: {
    id: 'Label.Final',
    defaultMessage: 'Final'
  },
  experience: {
    id: 'Label.Experience',
    defaultMessage: 'Experience'
  },
  subject: {
    id: 'Label.Subject',
    defaultMessage: 'Subject'
  },
  copy: {
    id: 'Label.Copy',
    defaultMessage: 'Copy'
  },
  experienceReview: {
    id: 'Label.ExperienceReview',
    defaultMessage: 'Experience'
  },
  standardsReview: {
    id: 'Label.StandardsReview',
    defaultMessage: 'Standards'
  },
  subjectReview: {
    id: 'Label.SubjectReview',
    defaultMessage: 'Subject'
  },
  review: {
    id: 'Label.Review',
    defaultMessage: 'review'
  },
  blankReview: {
    id: 'Label.BlankReview',
    defaultMessage: '{reviewType} {review}'
  },
  author: {
    id: 'Label.Author',
    defaultMessage: 'Author'
  },
  authorOrganization: {
    id: 'Label.AuthorOrganization',
    defaultMessage: 'Author Organization'
  },
  tags: {
    id: 'Label.Tags',
    defaultMessage: 'Tags'
  },
  primarySubject: {
    id: 'Label.PrimarySubject',
    defaultMessage: 'Primary Subject'
  },
  assignedTo: {
    id: 'Label.AssignedTo',
    defaultMessage: 'Assigned To'
  },
  status: {
    id: 'Label.Status',
    defaultMessage: 'Status'
  },
  targetGradeLevel: {
    id: 'Label.TargetGradeLevel',
    defaultMessage: 'Target Grade'
  }
})



// WEBPACK FOOTER //
// ./src/utils/messages/label.js